import React, { useEffect, useState } from 'react';
import JsonView from '@uiw/react-json-view';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import Strings from '../../../i18n';
import {
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { useGetDeviceD2cMutation } from '../../../services/device/deviceService';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';

interface D2cMessagesProps {
  id: string | null;
  clearSelectedDevices: () => void;
  openSideBar: boolean;
}

export const D2cMessages = ({
  id,
  clearSelectedDevices,
  openSideBar
}: D2cMessagesProps) => {
  const [getMessages, { data, isLoading, isSuccess }] =
    useGetDeviceD2cMutation();
  const [parserData, setParserData] = useState<any>();

  useEffect(() => {
    if (id) {
      getMessages(id);
    }
  }, []);

  useEffect(() => {
    if (!openSideBar) {
      clearSelectedDevices();
    }
  }, [openSideBar]);

  useEffect(() => {
    if (data) {
      setParserData({
        macAddress: data.data.macAddress,
        telemetryData: JSON.parse(data.data.telemetryData)
      });
    }
  }, [data]);

  return (
    <Box height="95%">
      <StyledContainerItems>
        <StyledTitleSideBar>{Strings.common.d2cMessages}</StyledTitleSideBar>
      </StyledContainerItems>
      <Grid
        item
        xs={12}
        textAlign="left"
        sx={{ height: '85vh', overflow: 'auto' }}
      >
        {isLoading && <LoadingRowsComponent />}
        {isSuccess && data && parserData && (
          <JsonView
            value={parserData || {}}
            displayDataTypes={false}
            displayObjectSize={false}
            indentWidth={2}
          />
        )}
      </Grid>
      <div />
    </Box>
  );
};
